import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M5 16l1 -9l5 -5l6.5 6l-3.5 4l5 5l-8 5l-6 -6","key":"svg-0"}]]

const IconBrandBulma = createReactComponent('outline', 'brand-bulma', 'BrandBulma', __iconNode);

export default IconBrandBulma;